// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__HE9fk","buttons":"SendReceipts_buttons__3hiJ7","email":"SendReceipts_email__1sznC","bookApptTitle":"SendReceipts_bookApptTitle__5FTuI"};